import React from 'react';
import { SidemenuContextProps } from './HelpAndSupportMenu';

export const SideMenuSubpageContext = React.createContext<SidemenuContextProps>({
  page: 'index',
  flow: null,
});
